<template>
  <div class="donate_content" >
    <img class="donate_content_img" :src="returnImage()"  @click="moveDonate">
  </div>
</template>

<script>
import imageOption from "@/mixins/imageOption";
export default {
name: "DonateHomeLayout",
  mixins: [imageOption],
  components: {},
  inject: [],
  props: {
    infoData: {},
  },
  data() {
    return {}
  },
  beforeRouterEnter() {
  },
  created() {
  },
  mounted() {
  },
  beforeDestroy() {
  },
  destroyed() {

  },
  computed: {},
  methods: {
      moveDonate(){
          window.open('https://online.mrm.or.kr/RTsnoLd')
      },
    returnImage() {
      return `${this.infoData.org_url}`;
    },
    movePage(path) {
      if (this.$route.path === path) {
        return;
      }
      this.$router.push(path);
    },
  },
  watch: {},
}
</script>

<style scoped>

</style>